export default __webpack_public_path__ + "static/media/m-jobshub-02-v1.78c46976.jpg";